import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getAboutMembers = createAsyncThunk('get about members data', async () => {
  try {
    const result = await $api.get(`/members`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const createAboutMember = createAsyncThunk('create about member', async data => {
  try {
    const result = await $api.post(`/members`, data)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateAboutMember = createAsyncThunk(
  'update about members data',
  async ({ memberId, data }) => {
    try {
      const result = await $api.put(`/members/${memberId}`, data)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  },
)

export const deleteAboutMember = createAsyncThunk(
  'delete about members data',
  async ({ memberId }, { rejectWithValue }) => {
    try {
      const result = await $api.delete(`/members/${memberId}`)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  },
)

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
}

export const aboutMemberSlice = createSlice({
  name: 'about members',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAboutMembers.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getAboutMembers.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getAboutMembers.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })
  },
})

export const { actions: aboutMemberActions } = aboutMemberSlice
export const { reducer: aboutMemberReducer } = aboutMemberSlice
